import React from 'react';
import styled from 'styled-components';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import { EventConditionInfo } from '../../components';
import { getCapitalizedTimeUnitText } from '../../../../utils';
import {
  IDatePickerFieldsFragment,
  IRetentionQueryFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import DatePickerDisplay from '../../../Builder/DatePickerWidget/DateRangeDisplay/DatePickerDisplay';

interface IProps {
  query: IRetentionQueryFieldsFragment;
  datePicker: IDatePickerFieldsFragment;
}

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  column-gap: 8px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: start;
  column-gap: 8px;
`;

const RetentionRow = styled(Row)`
  margin-top: 8px;
`;

const Label = styled(BuilderInfoUI.HighlightedLabel)`
  flex: 0 0 56px;
`;

const StyledBorderedInfo = styled(BuilderInfoUI.BorderedInfo)`
  margin-right: 0;
`;

export default ({ query, datePicker }: IProps) => {
  return (
    <>
      <Row>
        <LeftContainer>
          <Label>Cohort</Label>
          <StyledBorderedInfo>
            <DatePickerDisplay datePicker={datePicker} />
          </StyledBorderedInfo>
          <StyledBorderedInfo>
            {getCapitalizedTimeUnitText(query.cohortUnit).adverb}
          </StyledBorderedInfo>
        </LeftContainer>
        <BuilderInfoUI.VerticalRow>
          {query.startConditions.map((eventCondition, eventIndex) => (
            <EventConditionInfo
              key={`retention-start-condition-${eventIndex}`}
              condition={eventCondition}
              label={'Starting Event(s)'}
              noMarginBottom={true}
            />
          ))}
        </BuilderInfoUI.VerticalRow>
      </Row>
      <RetentionRow>
        <LeftContainer>
          <Label>Retention</Label>
          <StyledBorderedInfo>{query.timeWindow} day(s)</StyledBorderedInfo>
          <StyledBorderedInfo>
            {query.customTimeBrackets?.length > 0
              ? 'Custom'
              : getCapitalizedTimeUnitText(query.retentionUnit).adverb}
          </StyledBorderedInfo>
        </LeftContainer>
        <BuilderInfoUI.VerticalRow>
          {query.returnConditions.map((eventCondition, eventIndex) => (
            <EventConditionInfo
              key={`retention-return-condition-${eventIndex}`}
              condition={eventCondition}
              label={'Returning Event(s)'}
              noMarginBottom={true}
            />
          ))}
        </BuilderInfoUI.VerticalRow>
      </RetentionRow>
    </>
  );
};
